// Public surface of the lecture-player feature. The shell route /lessons/:id
// renders LecturePage, which mounts LessonOutlet (the data-lecture-outlet anchor
// the shell stays decoupled from). When a lessonId is present we render the full
// interactive player; otherwise a friendly empty state.
import LecturePlayer from './components/LecturePlayer';

interface LessonOutletProps {
  lessonId?: string;
}

// Mount point the shell targets. Hosts the interactive lecture player.
export function LessonOutlet({ lessonId }: LessonOutletProps) {
  return (
    <div data-lecture-outlet data-lesson-id={lessonId} className="h-full">
      {lessonId ? (
        // key remounts the player cleanly when navigating between lessons.
        <LecturePlayer key={lessonId} lessonId={lessonId} />
      ) : (
        <div className="grid h-full place-items-center p-10 text-center">
          <p className="text-sm text-ws-ink-3">No lesson selected.</p>
        </div>
      )}
    </div>
  );
}

export { default as LecturePlayer } from './components/LecturePlayer';
export default LessonOutlet;
